import Loader from "react-loader-spinner";
import React, { useCallback, useEffect, useState, Fragment } from 'react';
import { BarChart, Bar, YAxis, XAxis, ResponsiveContainer, Legend, CartesianGrid, LineChart, Line } from "recharts";
import { salesReportByMonthOrYear, salesCountByCreator, loadSaleIndexPage, getSoldProductsList } from '../store/api/Invoice';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChartBar, faChartLine, faFileAlt, faFileInvoice, faListOl } from '@fortawesome/free-solid-svg-icons';
import { Card, Col, Row, Table } from 'react-bootstrap';
import { useHistory } from "react-router-dom";
const HomePage = () => {
    const history = useHistory();
    const [salesCount, getSalesCount] = useState([]);
    const [soldProducts, getSoldProducts] = useState([]);
    const [salesCount_Year, getSalesCount_Year] = useState([]);
    const [salesCount_User, getSalesCount_User] = useState([]);
    useEffect(() => {
        document.body.classList = "saleMain";
        const onGetReportData = (data) => {
            if (data.YearlySales) {
                getSalesCount_Year(data.YearlySales);
            }
            if (data.MonthlySales) {
                getSalesCount(data.MonthlySales);
            }
            if (data.UserlySales) {
                getSalesCount_User(data.UserlySales);
            }
            if (data.SoldProducts) {
                getSoldProducts(data.SoldProducts);
            }
        }
        loadSaleIndexPage("", " ", onGetReportData);
    }, []);
    const goToSearchInvoice = useCallback(() => {
        history.push("/Sale/SearchInvoice");
    });
    function renderLegend(props) {
        const { payload } = props;
        return (
            <Fragment>
                {
                    payload.map((entry, index) => (
                        <span key={`item-${index}`} style={{ color: `${entry.color}`, fontSize: "11px" }}>
                            <div style={{ backgroundColor: `${entry.color}`, width: "10px", height: "10px", display: "inline-block" }}></div>
                            &nbsp;{entry.value.replace("Count", "تعداد")}
                        </span>
                    ))
                }
            </Fragment>
        );
    }
    return (
        <div>
            <img style={{ marginTop: "10px", marginBottom: "10px" }} alt="" />
            <div className="container-fluid mt-3">
                <Row className="g-4">
                    <Col md={6}>
                        <Card className="saleCards" style={{ "--mainColor": "rgb(200 107 200)", "--footerColor": "rgb(101, 115, 208)", height: "310px" }}>
                            <Card.Header style={{ color: "black", border: "none", padding: "5px" }}>
                                <div className="go-corner">

                                    <FontAwesomeIcon icon={faChartLine} size="lg" color="white" onClick={() => salesReportByMonthOrYear(true, " ", getSalesCount)} />
                                    &nbsp;&nbsp;
                                </div>
                            </Card.Header>

                            <Card.Body>
                                {
                                    salesCount === "PENDING" &&
                                    <Loader type="BallTriangle" width={30} height={30} className="loader" />
                                }
                                {salesCount && Array.isArray(salesCount) &&
                                    <ResponsiveContainer width="105%" height="100%" className="barChart" debounce={300}>
                                        <LineChart data={salesCount}>
                                            <Legend align="center" content={renderLegend} verticalAlign="bottom" />
                                            <XAxis dataKey="MonthStr" style={{ fontSize: "8px" }} reversed={true} minTickGap={1} width={100} padding={{ left: 15 }} />
                                            <YAxis dx={15} style={{ fontSize: "10px" }} orientation="right" padding={{ top: 15 }} tickMargin={5} />
                                            <CartesianGrid stroke="#c08ec3b0" />
                                            <Line dataKey="Count" type="linear" fill="blue" label={{ position: 'top' }} isAnimationActive={false} />
                                        </LineChart>
                                    </ResponsiveContainer>
                                }
                            </Card.Body>
                            <Card.Footer style={{ color: "whitesmoke" }} >
                                <FontAwesomeIcon icon={faFileInvoice} size="lg" color="white" onClick={goToSearchInvoice} style={{ cursor: "pointer" }} />
                                &nbsp;
                                آمار فروش ماهانه
                            </Card.Footer>

                        </Card>
                    </Col>
                    <Col md={6}>
                        <Card className="saleCards" style={{ "--mainColor": "rgb(132 111 230)", "--footerColor": "rgb(208 101 178)", height: "310px" }}>
                            <Card.Header style={{ color: "black", border: "none", padding: "5px" }}>
                                <div className="go-corner">

                                    <FontAwesomeIcon icon={faChartLine} size="lg" color="white" onClick={() => salesReportByMonthOrYear(false, " ", getSalesCount_Year)} />
                                    &nbsp;&nbsp;
                                </div>
                            </Card.Header>

                            <Card.Body>
                                {
                                    salesCount_Year === "PENDING" &&
                                    <Loader type="BallTriangle" width={30} height={30} className="loader" />
                                }
                                {salesCount_Year && Array.isArray(salesCount_Year) &&
                                    <ResponsiveContainer width="105%" height="100%" className="barChart" debounce={300}>
                                        <LineChart data={salesCount_Year}>
                                            <Legend align="center" content={renderLegend} verticalAlign="bottom" />
                                            <XAxis dataKey="Year" style={{ fontSize: "8px" }} reversed={true} minTickGap={1} width={100} padding={{ left: 15 }} />
                                            <YAxis dx={15} style={{ fontSize: "10px" }} orientation="right" padding={{ top: 15 }} tickMargin={5} />
                                            <CartesianGrid stroke="#b1b1db" />
                                            <Line dataKey="Count" type="monotoneY" fill="#a24fc1" stroke="#a24fc1" label={{ position: 'top' }} isAnimationActive={false} />
                                        </LineChart>
                                    </ResponsiveContainer>
                                }
                            </Card.Body>
                            <Card.Footer style={{ color: "whitesmoke" }} >
                                <FontAwesomeIcon icon={faFileAlt} size="lg" color="white" onClick={goToSearchInvoice} style={{ cursor: "pointer" }} />
                                &nbsp;
                                آمار فروش سالانه
                            </Card.Footer>

                        </Card>
                    </Col>
                    <Col md={6}>
                        <Card className="saleCards" style={{ "--mainColor": "#e6786f", "--footerColor": "#399396", height: "310px" }}>
                            <Card.Header style={{ color: "black", border: "none", padding: "5px" }}>
                                <div className="go-corner">

                                    <FontAwesomeIcon icon={faChartBar} size="lg" color="white" onClick={() => salesCountByCreator("", getSalesCount_User)} />
                                    &nbsp;&nbsp;
                                </div>
                            </Card.Header>

                            <Card.Body>
                                {
                                    salesCount_User === "PENDING" &&
                                    <Loader type="BallTriangle" width={30} height={30} className="loader" />
                                }
                                {salesCount_User && Array.isArray(salesCount_User) &&
                                    <ResponsiveContainer width="105%" height="100%" className="barChart" debounce={300}>
                                        <BarChart data={salesCount_User}>
                                            <Legend align="center" content={renderLegend} verticalAlign="bottom" />
                                            <XAxis dataKey="User" style={{ fontSize: "8px" }} reversed={true} minTickGap={1} width={100} padding={{ left: 15 }} />
                                            <YAxis dx={15} style={{ fontSize: "10px" }} orientation="right" padding={{ top: 15 }} tickMargin={5} />
                                            <CartesianGrid stroke="#e19b7294" />
                                            <Bar dataKey="Count" fill="#549cb9" label={{ position: 'top' }} isAnimationActive={false} />
                                        </BarChart>
                                    </ResponsiveContainer>
                                }
                            </Card.Body>
                            <Card.Footer style={{ color: "whitesmoke" }} >
                                <FontAwesomeIcon icon={faFileInvoice} size="lg" color="white" onClick={goToSearchInvoice} style={{ cursor: "pointer" }} />
                                &nbsp;
                                فروش به تفکیک کاربران
                            </Card.Footer>

                        </Card>
                    </Col>
                    <Col md={6}>
                        <Card className="saleCards" style={{ "--mainColor": "#4c3ac4", "--footerColor": "#728ee8", height: "310px" }}>
                            <Card.Header style={{ color: "black", border: "none", padding: "5px" }}>
                                <div className="go-corner">

                                    <FontAwesomeIcon icon={faListOl} size="lg" color="white" onClick={() => getSoldProductsList("", getSoldProducts)} />
                                    &nbsp;&nbsp;
                                </div>
                            </Card.Header>

                            <Card.Body>
                                {soldProducts === "PENDING" && <Loader type="BallTriangle" width={30} height={30} className="loader" />}
                                {soldProducts && Array.isArray(soldProducts) &&
                                    <div style={{ maxHeight: "220px", overflowY: "auto" }} className="hideScroll">
                                        <Table className="designedTable" style={{ "--rowColor": "#dee9fa91" }}>
                                            <thead style={{ background: "#756cb8", color: "whitesmoke" }}>
                                                <tr>
                                                    <th>مارک</th>
                                                    <th>نام</th>
                                                    <th>مدل</th>
                                                    <th>تعداد</th>
                                                </tr>
                                            </thead>
                                            <tbody style={{ textAlign: "right", borderTop: "1px solid gray" }}>
                                                {soldProducts.map((row, i) => <tr key={i} >
                                                    <td>{row.Holder}</td>
                                                    <td>{row.Name}</td>
                                                    <td>{row.Model}</td>
                                                    <td>{row.Count}</td>
                                                </tr>)}
                                            </tbody>
                                        </Table>
                                    </div>
                                }
                            </Card.Body>
                            <Card.Footer style={{ color: "whitesmoke" }} >
                                <FontAwesomeIcon icon={faFileInvoice} size="lg" color="white" onClick={goToSearchInvoice} style={{ cursor: "pointer" }} />
                                &nbsp;
                                لیست کالاهای فروش رفته
                            </Card.Footer>

                        </Card>
                    </Col>
                </Row>
            </div>
        </div>

    )

}

export default HomePage;